import { render } from "./IconFitBand.vue?vue&type=template&id=23f4d09a"
import script from "./IconFitBand.vue?vue&type=script&lang=js"
export * from "./IconFitBand.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__